"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingElement = void 0;
exports.indexOf = indexOf;
exports.removeItem = removeItem;
exports.unique = unique;
exports.sortKeysByValuesAsc = sortKeysByValuesAsc;
exports.sortKeysByValuesDesc = sortKeysByValuesDesc;
exports.intersect = intersect;
exports.findIndex = findIndex;
exports.find = find;
exports.shuffle = shuffle;
exports.getMatchingElementsWithIndices = getMatchingElementsWithIndices;
exports.extractMatchingElements = extractMatchingElements;
exports.contains = contains;
exports.maxBy = maxBy;
exports.minBy = minBy;
var _indexOf;
if (typeof Array.prototype.indexOf === "function")
    // newer browsers
    _indexOf = function (arr, item) { return arr.indexOf(item); };
else
    _indexOf = function (arr, item) {
        var index = -1;
        for (var i = 0; i < this.length; i++) {
            if (arr[i] === item) {
                index = i;
                break;
            }
        }
        return index;
    };
function indexOf(arr, item) {
    return _indexOf(arr, item);
}
function removeItem(arr, item) {
    var pos = indexOf(arr, item);
    if (pos >= 0)
        arr.splice(pos);
}
function unique(arr, func) {
    var dict = {};
    arr.forEach(function (item) { return (dict[func(item)] = item); });
    var values = [];
    for (var key in dict) {
        if (dict.hasOwnProperty(key)) {
            values.push(dict[key]);
        }
    }
    return values;
}
function sortKeysByValuesAsc(obj) {
    return Object.keys(obj).sort(function (a, b) { return obj[a] - obj[b]; });
}
function sortKeysByValuesDesc(obj) {
    return Object.keys(obj).sort(function (a, b) { return obj[b] - obj[a]; });
}
function intersect(arr1, arr2) {
    var r = [], o = {}, l = arr2.length, i, v;
    for (i = 0; i < l; i++) {
        o[arr2[i]] = true;
    }
    l = arr1.length;
    for (i = 0; i < l; i++) {
        v = arr1[i];
        if (v in o) {
            r.push(v);
        }
    }
    return r;
}
function findIndex(arr, predicate) {
    for (var i = 0; i < arr.length; i++) {
        if (predicate(arr[i]))
            return i;
    }
    return -1;
}
function find(arr, predicate) {
    for (var i = 0; i < arr.length; i++) {
        if (predicate(arr[i]))
            return arr[i];
    }
    return null;
}
function shuffle(array) {
    var counter = array.length;
    // While there are elements in the array
    while (counter > 0) {
        // Pick a random index
        var index = Math.floor(Math.random() * counter);
        // Decrease counter by 1
        counter--;
        // And swap the last element with it
        var temp = array[counter];
        array[counter] = array[index];
        array[index] = temp;
    }
    return array;
}
var MatchingElement = /** @class */ (function () {
    function MatchingElement(element, originalIndex) {
        this.element = element;
        this.originalIndex = originalIndex;
    }
    return MatchingElement;
}());
exports.MatchingElement = MatchingElement;
function getMatchingElementsWithIndices(array, predicate) {
    var indices = [];
    array.forEach(function (el, i) {
        if (predicate(el))
            indices.push(new MatchingElement(el, i));
    });
    return indices;
}
function extractMatchingElements(array, predicate) {
    var matching = [];
    for (var i = array.length - 1; i >= 0; i--) {
        var element = array[i];
        if (predicate(element, i)) {
            matching.unshift(element);
            array.splice(i, 1);
        }
    }
    return matching;
}
function contains(array, element) {
    return array.indexOf(element) >= 0;
}
function maxBy(array, valueGetter) {
    var maxIndex = 0;
    var maxValue = valueGetter(array[0]);
    for (var i = 1; i < array.length; i++) {
        var value = valueGetter(array[i]);
        if (maxValue < value) {
            maxValue = value;
            maxIndex = i;
        }
    }
    return array[maxIndex];
}
function minBy(array, valueGetter) {
    var minIndex = 0;
    var minValue = valueGetter(array[0]);
    for (var i = 1; i < array.length; i++) {
        var value = valueGetter(array[i]);
        if (minValue > value) {
            minValue = value;
            minIndex = i;
        }
    }
    return array[minIndex];
}
